import { useIsMobile } from '@/hooks/use-mobile'
import { MobileBlockedFallback } from './mobile-blocked-fallback'
import React from "react";

interface DeviceGuardProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export function DeviceGuard({ children, fallback }: DeviceGuardProps) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <>{fallback ?? <MobileBlockedFallback />}</>
  }

  return <>{children}</>
}
